import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setContext } from "../../../features/context";
import axiosCall from "../../../lib/axios";

const CommunityEdit = ({ language, community, setEditCommunity, signout }) => {
  ///////////////// INITIALIZE /////////////////
  const dispatch = useDispatch();

  const [ex_knowledge, setEx_knowledge] = useState(
    community.ex_knowledge || false
  );
  const [notify_pathways, setNotify_pathways] = useState(
    community.notify_pathways || false
  );

  ///////////////// FUNCTIONS /////////////////
  const applyChanges = async () => {
    let data = { cid: community._id };

    let dirty = false;

    if ((community.ex_knowledge || false) !== ex_knowledge) {
      dirty = true;
      data.ex_knowledge = ex_knowledge;
    }

    if ((community.notify_pathways || false) !== notify_pathways) {
      dirty = true;
      data.notify_pathways = notify_pathways;
    }

    if (dirty) {
      let result = await axiosCall("admin/community/config", data);
      if (result.success) {
        let context = { ...community };

        if (data.ex_knowledge !== undefined) {
          context.ex_knowledge = data.ex_knowledge;
        }

        if (data.notify_pathways !== undefined) {
          context.notify_pathways = data.notify_pathways;
        }

        // reset context and close editor
        dispatch(setContext(context));
        setEditCommunity(false);
      } else if (result.refresh) {
        // token has been refreshed, try again
        applyChanges();
      } else {
        // refresh token expired or unknown error
        signout();
      }
    }
  };

  ///////////////// RENDER GUI /////////////////
  return (
    <div className="page-section" style={{ marginTop: "0.5em" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ display: "flex" }}>
          <div className="heading-icon">{"|"}</div>
          <div className="subheading" style={{ overflow: "initial" }}>
            {language.labels.app.settings}
          </div>
        </div>
      </div>

      {/* ex_knowledge */}
      <div
        style={{
          marginTop: "1.5em",
          display: "flex",
          alignItems: "flex-start",
          gap: "0.5em",
        }}
      >
        <input
          id="ex_k_selector"
          value={ex_knowledge}
          type="checkbox"
          checked={ex_knowledge}
          onChange={() => {
            setEx_knowledge(!ex_knowledge);
          }}
        />
        <label htmlFor="ex_k_selector">
          {language.labels.communities.settings.ex_knowledge_label}
        </label>
      </div>

      {/* notify_pathways */}
      <div
        style={{
          marginTop: "1.5em",
          display: "flex",
          alignItems: "flex-start",
          gap: "0.5em",
        }}
      >
        <input
          id="notify_pathways_selector"
          value={notify_pathways}
          type="checkbox"
          checked={notify_pathways}
          onChange={() => {
            setNotify_pathways(!notify_pathways);
          }}
        />
        <label htmlFor="notify_pathways_selector">
          {language.labels.communities.settings.notify_pathways_label}
        </label>
      </div>

      {/* buttons */}
      <div style={{ display: "flex", gap: "0.25em", margin: "3em 0" }}>
        <button
          className="button-secondary"
          onClick={() => setEditCommunity(false)}
        >
          {language.labels.app.cancel}
        </button>
        <button className="button" onClick={applyChanges}>
          {language.labels.app.apply}
        </button>
      </div>
    </div>
  );
};

export default CommunityEdit;
